import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#7b79eb',
    },
    secondary: {
      // main: '#19857b',
      main: '#c5020b'
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
  typography: {
    fontFamily: "'Noto Sans KR', sans-serif",
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: '999px',
        fontWeight: 400,
        textTransform: 'none'
      }, 
    }, 
  }, 
});

export default theme;